/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import './Modal.scss';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      email_recipient: this.props.student_email
    }

    this.onChange = this.onChange.bind(this)
  }

  onChange(name) {
    return (event)=>{
      let {
        onFormChange,
      } = this.props;

      this.setState({
        [name]: event.target.value
      }, ()=>{
        onFormChange(this.state)
      });
    }
  }

  render() {
    const {student, operator_name, transaction_number, student_email} = this.props
    return (
      <div className='transaction-summary-modal-content'>
        <div className='container-fluid'>
          <div className='text-center'>
            <label>{__('Student: ', 'finance')}</label>
            <span>{student}</span>
          </div>
          <div className='text-center'>
            <label>{__('Operator: ', 'finance')}</label>
            <span>{operator_name}</span>
          </div>
          <div className='text-center transaction-receipt'>
            <label>{__('E-Receipt Number: ', 'finance')}</label>
            <span>{transaction_number}</span>
          </div>
          <div className='text-center'>
            <h5>{__('Send To', 'finance')}</h5>
            <div className="input-group">
              <span className="input-group-addon"><i className="fa icon-envelope"></i></span>
              <input type="text" className="form-control" value={this.state.email_recipient} onChange={this.onChange('email_recipient')}/>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/TransactionSummary/ModalContent.js